import '../scss/main.scss';
// import { register_oembed5k } from './lib/oembed5k.js';
// import { register_form } from './lib/form5k.js';
import { decryptMailtoAndPhone } from './functions.js';
//import { registerUploadField } from './lib/form5k-upload.js';

if (process.env.NODE_ENV !== 'production') {
    import("./dev").then((module) => {

    })
}

window.addEventListener('load', (event) => {
    //register_form(document);
    //register_oembed5k(document);
    decryptMailtoAndPhone();
    //registerUploadField(document);
});

register_scroll_direction(document);
function register_scroll_direction($root = document) {
    const $html = $root.querySelector('html');
    var lastScrollTop = 0;
    var scrollDirection = 'up';
    $html.classList.add('state--scroll--' + scrollDirection);
    document.documentElement.dataset.scroll = 0;
    window.addEventListener('scroll', () => {
        var st = window.scrollY || document.documentElement.scrollTop;
        // console.log('st', st);
        // console.log('lastScrollTop', lastScrollTop);
        var headerHeightCssVar = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
        // console.log('headerHeightCssVar', headerHeightCssVar);
        if (st > lastScrollTop) {
            if (st > headerHeightCssVar) {
                scrollDirection = 'down';
            }
        } else {
            scrollDirection = 'up';
        }
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
        $html.classList.remove('state--scroll--up');
        $html.classList.remove('state--scroll--down');
        $html.classList.add('state--scroll--' + scrollDirection);
        document.documentElement.dataset.scroll = st;
    }, false);
}

register_header_burger(document);
function register_header_burger($root = document) {
    const $burgerButton = $root.querySelector('#header .container .burger');
    const $html = $root.querySelector('html');
    $burgerButton.addEventListener('click', function () {
        $html.classList.toggle("state--menu--is-open");
    });
}

function check($fieldset) {
    const $inputs = $fieldset.querySelectorAll('input, select, textarea');
    let err = false;
    let $input_first = null;
    let at_least_one = $fieldset.dataset.at_least_one !== 'true';
    console.log({ at_least_one });
    $inputs.forEach($input => {
        console.log($input.name, $input.value);
        if ($input.value !== '' && $input.value !== 0 && $input.value !== '0' && $input.value !== 'on' || $input.checked) {
            at_least_one = true;
        }
        if ($input.required && $input.value === '' || !$input.validity.valid) {
            if (!$input_first) {
                $input_first = $input;
            }
            $input.parentNode.classList.add('error');
            err = true;
        } else {
            $input.parentNode.classList.remove('error');
        }
    });
    if (!at_least_one) {
        err = true;
        $input_first = [...$inputs][0];
    }
    if (err) {
        $input_first.scrollIntoView({ behavior: 'smooth', block: 'start' });
        $input_first.focus({ preventScroll: true });
    }
    return err;
}

register_contact_form(document);
function register_contact_form($root = document) {
    const $form = $root.querySelector('#contact-form-form');
    if (!$form) {
        return;
    }
    // const $submit = $form.parentNode.querySelector('button[type="submit"]');
    // $submit.addEventListener('click', event => {
    //     event.preventDefault();
    //     console.log('submit')

    //     if (err) {
    //         return;
    //     }
    //     $form.dispatchEvent(new Event('submit'));
    // });
    $form.addEventListener('submit', event => {
        event.preventDefault();
        const err = check($form.parentNode);
        console.log({ err });
        if (err) {
            return;
        }
        let $contactForm = document.getElementById('contact-form');
        console.log('$contactForm', $contactForm);
        $contactForm.classList.add('sending');
        const config = JSON.parse($form.dataset.config);
        const form_data = new FormData(event.target);
        console.log({ config });
        const clean_data = [];
        for (const [name, value] of form_data.entries()) {
            if (value === '') {
                continue;
            }
            const $el = $form.elements[name];
            let clean_value;
            switch ($el.type) {
                case "checkbox":
                    clean_value = value === "on";
                    break
                case "number":
                    clean_value = parseFloat(value);
                    break
                default:
                    clean_value = value;
                    break
            }
            clean_data.push([name, clean_value]);
        }
        const request_body = Object.fromEntries(clean_data);
        request_body.meta = config.meta;
        fetch(config.form.action, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(request_body)
        })
            .then(result => result.json())
            .then(data => {
                console.log(data);
                $contactForm.classList.remove('sending');
                $contactForm.classList.add('thank-you');

                if (!data.message) {
                    //@todo
                    return;
                }

                const $contactFormThankYou = document.getElementById('contact-form-thank-you');
                $contactFormThankYou.innerHTML = "";
                const $message = document.createElement('p');
                $message.innerHTML = data.message;
                $contactFormThankYou.appendChild($message);
            })
            .catch(console.warn);
    });
}


register_open_modal_click(document);
function register_open_modal_click($root = document) {
    $root.querySelectorAll('a[href^="openmodal:"]').forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            const href = this.href.substring(10);
            if (href === "contactform") {
                $root.documentElement.classList.add('state--contact-form--is-open');
                $root.documentElement.classList.remove('state--menu--is-open');
                $root.querySelector('#contact-form').focus();
            }
        });
    });
}


register_close_modal_click(document);
function register_close_modal_click($root = document) {
    $root.querySelectorAll('.modal-form .burger').forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            $root.documentElement.classList.remove('state--contact-form--is-open');
        });
    });
}


register_checkbox_radios(document);
function register_checkbox_radios($root = document) {
    $root.querySelectorAll('input.form-check-input-radio').forEach($checkbox => {
        $checkbox.addEventListener('click', function (e) {
            $checkbox.closest('.form-group-inline').querySelectorAll('input').forEach(input => {
                if (input !== this) {
                    input.checked = false;
                }
            });
        });
    });
}

register_esc_for_handling_the_right_stuff(document);
function register_esc_for_handling_the_right_stuff($root = document) {
    document.addEventListener('keydown', function (event) {
        if (event.key === "Escape") {
            const $html = document.querySelector('html');
            if ($html.classList.contains('state--menu--is-open')) {
                $html.classList.remove('state--menu--is-open');
                return;
            }
            if ($html.classList.contains('state--contact-form--is-open')) {
                $html.classList.remove('state--contact-form--is-open');
                return;
            }
        }
    });
}